import ApplicationController from './application_controller'

class AutoRefreshController extends ApplicationController {
  static targets = ['refreshLink']
  static values = {
    interval: { type: Number, default: 5000 }
  }

  connect () {
    this.startPolling()
  }

  disconnect () {
    this.stopPolling()
  }

  startPolling () {
    this.stopPolling()
    this.pollingInterval = setInterval(() => {
      this.refresh()
    }, this.intervalValue)
  }

  stopPolling () {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval)
    }
  }

  refresh () {
    if (this.hasRefreshLinkTarget) {
      this.refreshLinkTarget.click()
    }
  }
}

export default AutoRefreshController
